/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ClinicalReportMaterialResultDtoClinicalDetectionMethod =
  (typeof ClinicalReportMaterialResultDtoClinicalDetectionMethod)[keyof typeof ClinicalReportMaterialResultDtoClinicalDetectionMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicalReportMaterialResultDtoClinicalDetectionMethod = {
  PCR: 'PCR',
  CULTURE: 'CULTURE',
  MICROSCOPY: 'MICROSCOPY',

} as const;
